import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <DModal
  id="choosing-topic"
  @title={{i18n "topic.move_to.title"}}
  @closeModal={{@closeModal}}
  class="choose-topic-modal"
  @flash={{this.flash}}
  @flashType="error"
>
  <:body>
    {{#if @model.topic.isPrivateMessage}}
      <div class="radios">
        {{#if this.canSplitToPM}}
          <label class="radio-label" for="move-to-new-message">
            <RadioButton
              id="move-to-new-message"
              @name="move-to-entity"
              @value="new_message"
              @selection={{this.selection}}
            />
            <b>{{i18n "topic.move_to_new_message.radio_label"}}</b>
          </label>
        {{/if}}

        <label class="radio-label" for="move-to-existing-message">
          <RadioButton
            id="move-to-existing-message"
            @name="move-to-entity"
            @value="existing_message"
            @selection={{this.selection}}
          />
          <b>{{i18n "topic.move_to_existing_message.radio_label"}}</b>
        </label>
      </div>

      {{#if this.canSplitTopic}}
        {{#if this.newMessage}}
          <p>
            {{html-safe
              (i18n
                "topic.move_to_new_message.instructions"
                count=@model.selectedPostsCount
              )
            }}
          </p>
          <form>
            <label>{{i18n "topic.move_to_new_message.message_title"}}</label>
            <TextField
              @value={{this.topicName}}
              @placeholderKey="composer.title_placeholder"
              id="split-topic-name"
            />

            {{#if this.canTagMessages}}
              <label>{{i18n "tagging.tags"}}</label>
              <TagChooser @tags={{this.tags}} />
            {{/if}}
          </form>
        {{/if}}
      {{/if}}

      {{#if this.existingMessage}}
        <p>
          {{html-safe
            (i18n
              "topic.move_to_existing_message.instructions"
              count=@model.selectedPostsCount
            )
          }}
        </p>
        <form>
          <ChooseMessage
            @currentTopicId={{@model.topic.id}}
            @selectedTopicId={{this.selectedTopicId}}
          />

          <label>{{i18n "topic.move_to_new_message.participants"}}</label>
          <EmailGroupUserChooser
            class="participant-selector"
            @value={{this.participants}}
            @onChange={{fn (mut this.participants)}}
          />

          {{#if this.selectedTopicId}}
            <hr />
            <label for="chronological-order" class="checkbox-label">
              <Input
                id="chronological-order"
                @type="checkbox"
                @checked={{this.chronologicalOrder}}
              />
              {{i18n "topic.merge_topic.chronological_order"}}
            </label>
          {{/if}}
        </form>
      {{/if}}

    {{else}}
      <div class="radios">
        {{#if this.canSplitTopic}}
          <label class="radio-label" for="move-to-new-topic">
            <RadioButton
              id="move-to-new-topic"
              @name="move-to-entity"
              @value="new_topic"
              @selection={{this.selection}}
            />
            <b>{{i18n "topic.split_topic.radio_label"}}</b>
          </label>
        {{/if}}

        <label class="radio-label" for="move-to-existing-topic">
          <RadioButton
            id="move-to-existing-topic"
            @name="move-to-entity"
            @value="existing_topic"
            @selection={{this.selection}}
          />
          <b>{{i18n "topic.merge_topic.radio_label"}}</b>
        </label>

        {{#if this.canSplitToPM}}
          <label class="radio-label" for="move-to-new-message">
            <RadioButton
              id="move-to-new-message"
              @name="move-to-entity"
              @value="new_message"
              @selection={{this.selection}}
            />
            <b>{{i18n "topic.move_to_new_message.radio_label"}}</b>
          </label>
        {{/if}}
      </div>

      {{#if this.existingTopic}}
        <p>
          {{html-safe
            (i18n
              "topic.merge_topic.instructions" count=@model.selectedPostsCount
            )
          }}
        </p>
        <form>
          <ChooseTopic
            @topicChangedCallback={{this.newTopicSelected}}
            @currentTopicId={{@model.topic.id}}
          />

          {{#if this.selectedTopicId}}
            <hr />
            <label for="chronological-order" class="checkbox-label">
              <Input
                id="chronological-order"
                @type="checkbox"
                @checked={{this.chronologicalOrder}}
              />
              {{i18n "topic.merge_topic.chronological_order"}}
            </label>
          {{/if}}
        </form>
      {{/if}}

      {{#if this.canSplitTopic}}
        {{#if this.newTopic}}
          <p>
            {{html-safe
              (i18n
                "topic.split_topic.instructions" count=@model.selectedPostsCount
              )
            }}
          </p>
          <form class="split-new-topic-form">
            <div class="control-group">
              <label>{{i18n "topic.split_topic.topic_name"}}</label>
              <TextField
                @value={{this.topicName}}
                @placeholderKey="composer.title_placeholder"
                id="split-topic-name"
              />
              <PluginOutlet
                @name="split-new-topic-title-after"
                @outletArgs={{hash
                  selectedPosts=@model.selectedPosts
                  updateTopicName=this.updateTopicName
                }}
              />
            </div>

            <div class="control-group">
              <label>{{i18n "categories.category"}}</label>
              <CategoryChooser
                @value={{this.categoryId}}
                class="small"
                @onChange={{fn (mut this.categoryId)}}
              />
              <PluginOutlet
                @name="split-new-topic-category-after"
                @outletArgs={{hash
                  selectedPosts=@model.selectedPosts
                  updateCategoryId=this.updateCategoryId
                }}
              />
            </div>

            {{#if this.canAddTags}}
              <div class="control-group">
                <label>{{i18n "tagging.tags"}}</label>
                <TagChooser
                  @tags={{this.tags}}
                  @categoryId={{this.categoryId}}
                />
                <PluginOutlet
                  @name="split-new-topic-tag-after"
                  @outletArgs={{hash
                    selectedPosts=@model.selectedPosts
                    updateTags=this.updateTags
                    tags=this.tags
                  }}
                />
              </div>
            {{/if}}
          </form>
        {{/if}}
      {{/if}}

      {{#if this.canSplitTopic}}
        {{#if this.newMessage}}
          <p>
            {{html-safe
              (i18n
                "topic.move_to_new_message.instructions"
                count=@model.selectedPostsCount
              )
            }}
          </p>
          <form>
            <label>{{i18n "topic.move_to_new_message.message_title"}}</label>
            <TextField
              @value={{this.topicName}}
              @placeholderKey="composer.title_placeholder"
              id="split-topic-name"
            />

            {{#if this.canTagMessages}}
              <label>{{i18n "tagging.tags"}}</label>
              <TagChooser @tags={{this.tags}} />
            {{/if}}
          </form>
        {{/if}}
      {{/if}}
    {{/if}}
  </:body>
  <:footer>
    <DButton
      class="btn-primary"
      @disabled={{this.buttonDisabled}}
      @action={{this.performMove}}
      @icon="sign-out-alt"
      @label={{this.buttonTitle}}
    />
  </:footer>
</DModal>
*/
{
  "id": "8Tmfjvm8",
  "block": "[[[8,[39,0],[[24,1,\"choosing-topic\"],[24,0,\"choose-topic-modal\"]],[[\"@title\",\"@closeModal\",\"@flash\",\"@flashType\"],[[28,[37,1],[\"topic.move_to.title\"],null],[30,1],[30,0,[\"flash\"]],\"error\"]],[[\"body\",\"footer\"],[[[[1,\"\\n\"],[41,[30,2,[\"topic\",\"isPrivateMessage\"]],[[[1,\"      \"],[10,0],[14,0,\"radios\"],[12],[1,\"\\n\"],[41,[30,0,[\"canSplitToPM\"]],[[[1,\"          \"],[10,\"label\"],[14,0,\"radio-label\"],[14,\"for\",\"move-to-new-message\"],[12],[1,\"\\n            \"],[8,[39,3],[[24,1,\"move-to-new-message\"]],[[\"@name\",\"@value\",\"@selection\"],[\"move-to-entity\",\"new_message\",[30,0,[\"selection\"]]]],null],[1,\"\\n            \"],[10,\"b\"],[12],[1,[28,[35,1],[\"topic.move_to_new_message.radio_label\"],null]],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n        \"],[10,\"label\"],[14,0,\"radio-label\"],[14,\"for\",\"move-to-existing-message\"],[12],[1,\"\\n          \"],[8,[39,3],[[24,1,\"move-to-existing-message\"]],[[\"@name\",\"@value\",\"@selection\"],[\"move-to-entity\",\"existing_message\",[30,0,[\"selection\"]]]],null],[1,\"\\n          \"],[10,\"b\"],[12],[1,[28,[35,1],[\"topic.move_to_existing_message.radio_label\"],null]],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"canSplitTopic\"]],[[[41,[30,0,[\"newMessage\"]],[[[1,\"          \"],[10,2],[12],[1,\"\\n            \"],[1,[28,[35,4],[[28,[37,1],[\"topic.move_to_new_message.instructions\"],[[\"count\"],[[30,2,[\"selectedPostsCount\"]]]]]],null]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,\"form\"],[12],[1,\"\\n            \"],[10,\"label\"],[12],[1,[28,[35,1],[\"topic.move_to_new_message.message_title\"],null]],[13],[1,\"\\n            \"],[8,[39,5],[[24,1,\"split-topic-name\"]],[[\"@value\",\"@placeholderKey\"],[[30,0,[\"topicName\"]],\"composer.title_placeholder\"]],null],[1,\"\\n\\n\"],[41,[30,0,[\"canTagMessages\"]],[[[1,\"              \"],[10,\"label\"],[12],[1,[28,[35,1],[\"tagging.tags\"],null]],[13],[1,\"\\n              \"],[8,[39,6],null,[[\"@tags\"],[[30,0,[\"tags\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"          \"],[13],[1,\"\\n\"]],[]],null]],[]],null],[1,\"\\n\"],[41,[30,0,[\"existingMessage\"]],[[[1,\"        \"],[10,2],[12],[1,\"\\n          \"],[1,[28,[35,4],[[28,[37,1],[\"topic.move_to_existing_message.instructions\"],[[\"count\"],[[30,2,[\"selectedPostsCount\"]]]]]],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,\"form\"],[12],[1,\"\\n          \"],[8,[39,7],null,[[\"@currentTopicId\",\"@selectedTopicId\"],[[30,2,[\"topic\",\"id\"]],[30,0,[\"selectedTopicId\"]]]],null],[1,\"\\n\\n          \"],[10,\"label\"],[12],[1,[28,[35,1],[\"topic.move_to_new_message.participants\"],null]],[13],[1,\"\\n          \"],[8,[39,8],[[24,0,\"participant-selector\"]],[[\"@value\",\"@onChange\"],[[30,0,[\"participants\"]],[28,[37,9],[[28,[37,10],[[30,0,[\"participants\"]]],null]],null]]],null],[1,\"\\n\\n\"],[41,[30,0,[\"selectedTopicId\"]],[[[1,\"            \"],[10,\"hr\"],[12],[13],[1,\"\\n            \"],[10,\"label\"],[14,\"for\",\"chronological-order\"],[14,0,\"checkbox-label\"],[12],[1,\"\\n              \"],[8,[39,11],[[24,1,\"chronological-order\"]],[[\"@type\",\"@checked\"],[\"checkbox\",[30,0,[\"chronologicalOrder\"]]]],null],[1,\"\\n              \"],[1,[28,[35,1],[\"topic.merge_topic.chronological_order\"],null]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null],[1,\"        \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"]],[]],[[[1,\"      \"],[10,0],[14,0,\"radios\"],[12],[1,\"\\n\"],[41,[30,0,[\"canSplitTopic\"]],[[[1,\"          \"],[10,\"label\"],[14,0,\"radio-label\"],[14,\"for\",\"move-to-new-topic\"],[12],[1,\"\\n            \"],[8,[39,3],[[24,1,\"move-to-new-topic\"]],[[\"@name\",\"@value\",\"@selection\"],[\"move-to-entity\",\"new_topic\",[30,0,[\"selection\"]]]],null],[1,\"\\n            \"],[10,\"b\"],[12],[1,[28,[35,1],[\"topic.split_topic.radio_label\"],null]],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n        \"],[10,\"label\"],[14,0,\"radio-label\"],[14,\"for\",\"move-to-existing-topic\"],[12],[1,\"\\n          \"],[8,[39,3],[[24,1,\"move-to-existing-topic\"]],[[\"@name\",\"@value\",\"@selection\"],[\"move-to-entity\",\"existing_topic\",[30,0,[\"selection\"]]]],null],[1,\"\\n          \"],[10,\"b\"],[12],[1,[28,[35,1],[\"topic.merge_topic.radio_label\"],null]],[13],[1,\"\\n        \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"canSplitToPM\"]],[[[1,\"          \"],[10,\"label\"],[14,0,\"radio-label\"],[14,\"for\",\"move-to-new-message\"],[12],[1,\"\\n            \"],[8,[39,3],[[24,1,\"move-to-new-message\"]],[[\"@name\",\"@value\",\"@selection\"],[\"move-to-entity\",\"new_message\",[30,0,[\"selection\"]]]],null],[1,\"\\n            \"],[10,\"b\"],[12],[1,[28,[35,1],[\"topic.move_to_new_message.radio_label\"],null]],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[1,\"      \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"existingTopic\"]],[[[1,\"        \"],[10,2],[12],[1,\"\\n          \"],[1,[28,[35,4],[[28,[37,1],[\"topic.merge_topic.instructions\"],[[\"count\"],[[30,2,[\"selectedPostsCount\"]]]]]],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,\"form\"],[12],[1,\"\\n          \"],[8,[39,12],null,[[\"@topicChangedCallback\",\"@currentTopicId\"],[[30,0,[\"newTopicSelected\"]],[30,2,[\"topic\",\"id\"]]]],null],[1,\"\\n\\n\"],[41,[30,0,[\"selectedTopicId\"]],[[[1,\"            \"],[10,\"hr\"],[12],[13],[1,\"\\n            \"],[10,\"label\"],[14,\"for\",\"chronological-order\"],[14,0,\"checkbox-label\"],[12],[1,\"\\n              \"],[8,[39,11],[[24,1,\"chronological-order\"]],[[\"@type\",\"@checked\"],[\"checkbox\",[30,0,[\"chronologicalOrder\"]]]],null],[1,\"\\n              \"],[1,[28,[35,1],[\"topic.merge_topic.chronological_order\"],null]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null],[1,\"        \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"canSplitTopic\"]],[[[41,[30,0,[\"newTopic\"]],[[[1,\"          \"],[10,2],[12],[1,\"\\n            \"],[1,[28,[35,4],[[28,[37,1],[\"topic.split_topic.instructions\"],[[\"count\"],[[30,2,[\"selectedPostsCount\"]]]]]],null]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,\"form\"],[14,0,\"split-new-topic-form\"],[12],[1,\"\\n            \"],[10,0],[14,0,\"control-group\"],[12],[1,\"\\n              \"],[10,\"label\"],[12],[1,[28,[35,1],[\"topic.split_topic.topic_name\"],null]],[13],[1,\"\\n              \"],[8,[39,5],[[24,1,\"split-topic-name\"]],[[\"@value\",\"@placeholderKey\"],[[30,0,[\"topicName\"]],\"composer.title_placeholder\"]],null],[1,\"\\n              \"],[8,[39,13],null,[[\"@name\",\"@outletArgs\"],[\"split-new-topic-title-after\",[28,[37,14],null,[[\"selectedPosts\",\"updateTopicName\"],[[30,2,[\"selectedPosts\"]],[30,0,[\"updateTopicName\"]]]]]]],null],[1,\"\\n            \"],[13],[1,\"\\n\\n            \"],[10,0],[14,0,\"control-group\"],[12],[1,\"\\n              \"],[10,\"label\"],[12],[1,[28,[35,1],[\"categories.category\"],null]],[13],[1,\"\\n              \"],[8,[39,15],[[24,0,\"small\"]],[[\"@value\",\"@onChange\"],[[30,0,[\"categoryId\"]],[28,[37,9],[[28,[37,10],[[30,0,[\"categoryId\"]]],null]],null]]],null],[1,\"\\n              \"],[8,[39,13],null,[[\"@name\",\"@outletArgs\"],[\"split-new-topic-category-after\",[28,[37,14],null,[[\"selectedPosts\",\"updateCategoryId\"],[[30,2,[\"selectedPosts\"]],[30,0,[\"updateCategoryId\"]]]]]]],null],[1,\"\\n            \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"canAddTags\"]],[[[1,\"              \"],[10,0],[14,0,\"control-group\"],[12],[1,\"\\n                \"],[10,\"label\"],[12],[1,[28,[35,1],[\"tagging.tags\"],null]],[13],[1,\"\\n                \"],[8,[39,6],null,[[\"@tags\",\"@categoryId\"],[[30,0,[\"tags\"]],[30,0,[\"categoryId\"]]]],null],[1,\"\\n                \"],[8,[39,13],null,[[\"@name\",\"@outletArgs\"],[\"split-new-topic-tag-after\",[28,[37,14],null,[[\"selectedPosts\",\"updateTags\",\"tags\"],[[30,2,[\"selectedPosts\"]],[30,0,[\"updateTags\"]],[30,0,[\"tags\"]]]]]]],null],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],null],[1,\"          \"],[13],[1,\"\\n\"]],[]],null]],[]],null],[1,\"\\n\"],[41,[30,0,[\"canSplitTopic\"]],[[[41,[30,0,[\"newMessage\"]],[[[1,\"          \"],[10,2],[12],[1,\"\\n            \"],[1,[28,[35,4],[[28,[37,1],[\"topic.move_to_new_message.instructions\"],[[\"count\"],[[30,2,[\"selectedPostsCount\"]]]]]],null]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,\"form\"],[12],[1,\"\\n            \"],[10,\"label\"],[12],[1,[28,[35,1],[\"topic.move_to_new_message.message_title\"],null]],[13],[1,\"\\n            \"],[8,[39,5],[[24,1,\"split-topic-name\"]],[[\"@value\",\"@placeholderKey\"],[[30,0,[\"topicName\"]],\"composer.title_placeholder\"]],null],[1,\"\\n\\n\"],[41,[30,0,[\"canTagMessages\"]],[[[1,\"              \"],[10,\"label\"],[12],[1,[28,[35,1],[\"tagging.tags\"],null]],[13],[1,\"\\n              \"],[8,[39,6],null,[[\"@tags\"],[[30,0,[\"tags\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"          \"],[13],[1,\"\\n\"]],[]],null]],[]],null]],[]]],[1,\"  \"]],[]],[[[1,\"\\n    \"],[8,[39,16],[[24,0,\"btn-primary\"]],[[\"@disabled\",\"@action\",\"@icon\",\"@label\"],[[30,0,[\"buttonDisabled\"]],[30,0,[\"performMove\"]],\"sign-out-alt\",[30,0,[\"buttonTitle\"]]]],null],[1,\"\\n  \"]],[]]]]]],[\"@closeModal\",\"@model\"],false,[\"d-modal\",\"i18n\",\"if\",\"radio-button\",\"html-safe\",\"text-field\",\"tag-chooser\",\"choose-message\",\"email-group-user-chooser\",\"fn\",\"mut\",\"input\",\"choose-topic\",\"plugin-outlet\",\"hash\",\"category-chooser\",\"d-button\"]]",
  "moduleName": "discourse/components/modal/move-to-topic.hbs",
  "isStrictMode": false
});